export enum TradeStatus {
  Active = 'active',
  Expired = 'expired',
  ExpiringSoon = 'expiringSoon',
  Pending = 'pending',
  None = 'none'
}

enum Cta {
  Active = 'shop with my trade-in',
  Expired = 'refresh my offer',
  Pending = 'shop now',
  None = 'get your offer'
}

export const ctaMap = {
  active: Cta.Active,
  expired: Cta.Expired,
  expiresSoon: Cta.Active,
  pending: Cta.Pending,
  none: Cta.None
};

enum StatusColor {
  Active = 'bg-green-2',
  Expired = 'bg-red-2',
  ExpiringSoon = 'bg-yellow-2',
  Pending = 'bg-blue-4'
}

export const statusColorMap = {
  active: StatusColor.Active,
  expired: StatusColor.Expired,
  expiringSoon: StatusColor.ExpiringSoon,
  pending: StatusColor.Pending
};

export const activeTradeStatuses = {
  active: TradeStatus.Active,
  expiringSoon: TradeStatus.ExpiringSoon
};
